import size from "../sizes";
import sublimationPrinting from "./templates/sublimation-printing";

export default [
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `
        <p>Бомбер - это плотная толстовка на молнии без ворота и капюшона. Женский и мужской вариант бомбера отличаются посадкой и шириной плеч. По бокам присутствуют карманы для удобства. Вы сами придумываете дизайн своего бомбера, после чего ваши друзья смогут только позавидовать уникальному стилю.</p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${sublimationPrinting}`
    }
  },
  {
    id: `size`,
    title: `Размерная сетка`,
    content: {
      table: size[`man_bomber`],
      sizeInfo: `bomber`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
